// Load any app-wide CSS here
import "terminal.css";
import "./App.css";

import Layout from "./Layout";

import Watchlist from "./Watchlist";

import BtcExplorer from "./BtcExplorer";
import BtcSearch from "./BtcSearch";
import NotFound from "./NotFound";

import BtcLive from "./BtcLive";
import Mempool from "./Mempool";
import Defi from "./Defi";

import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import CryptoGraphSearch from "./CryptoGraphSearch";
import { walletLists } from "./walletLists";

// Loaded on demand. This page and the wallet lookup are the only things that
// need the 17KB OFAC address list, so it rides in its own chunk instead of in
// the bundle every visitor downloads - the site is already heavier than is good
// for it.
//
// Charts is here for the same reason and a bigger number. chart.js is 68KB
// gzipped and nothing outside /charts touches it, so every visitor to the front
// page was paying for a page they may never open. Splitting it out took the main
// bundle from 293KB to 223KB on its own.
const Charts = lazy(() => import("./Charts"));
const SanctionedWallets = lazy(() => import("./SanctionedWallets"));
const WalletListPage = lazy(() => import("./WalletListPage"));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<BtcLive />} />

          <Route path="mempool" element={<Mempool />} />

          <Route path="watchlist" element={<Watchlist />} />

          <Route path="defi" element={<Defi />} />

          <Route
            path="charts"
            element={
              <Suspense fallback={null}>
                <Charts />
              </Suspense>
            }
          />
          <Route path="charts/:searchCharts" element={<CryptoGraphSearch />} />
          <Route path="btc-explorer" element={<BtcSearch />} />
          {/* before the :walletId route for readability; React Router ranks a
              static segment above a dynamic one either way */}
          <Route
            path="btc-explorer/sanctioned"
            element={
              <Suspense fallback={null}>
                <SanctionedWallets />
              </Suspense>
            }
          />
          {/* One static route per list rather than a :listSlug parameter.
              :listSlug and :walletId are both single dynamic segments, so they
              rank equally and the winner would come down to declaration order -
              and if the list route won, every wallet lookup would land on a
              list page instead. A static segment outranks a dynamic one, so
              these resolve cleanly and an address still reaches the explorer. */}
          {walletLists.map((list) => (
            <Route
              key={list.slug}
              path={`btc-explorer/${list.slug}`}
              element={
                <Suspense fallback={null}>
                  <WalletListPage slug={list.slug} />
                </Suspense>
              }
            />
          ))}
          <Route path="btc-explorer/:walletId" element={<BtcExplorer />} />

          {/* BTC Live is the home page now; keep the old path working */}
          <Route path="btc-live" element={<Navigate to="/" replace />} />

          {/* Netlify already answered 404 and served the prerendered version of
              this page; rendering it again is what keeps the words on screen.
              Redirecting to home instead turned every 404 into a page that
              claimed to exist. */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
